define("settings/controllers/overview/edit-email", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/service", "@glimmer/tracking", "ember-concurrency", "later/utils/constants"], function (_exports, _asyncArrowRuntime, _controller, _service, _tracking, _emberConcurrency, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/constants"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let EditEmailController = _exports.default = (_class = class EditEmailController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _initializerDefineProperty(this, "errors", _descriptor4, this);
      _initializerDefineProperty(this, "intl", _descriptor5, this);
      _initializerDefineProperty(this, "router", _descriptor6, this);
      _initializerDefineProperty(this, "email", _descriptor7, this);
      _initializerDefineProperty(this, "confirmEmail", _descriptor8, this);
      _defineProperty(this, "updateEmail", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (email) {
          const user = this.auth.currentUserModel;
          return user.updateEmail({
            email
          });
        }
      }), null, "updateEmail", null));
      _defineProperty(this, "handleClose", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.router.transitionTo('account.overview');
        }
      }), null, "handleClose", null));
      _defineProperty(this, "handleSubmit", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            const didConfirm = yield this.dialogManager.confirmation(this.intl.t('account.users.edit_email.confirmation_title', {
              email: this.email
            }), {
              description: this.intl.t('account.users.edit_email.confirmation_description', {
                email: this.email
              }),
              confirmButton: this.intl.t('account.users.edit_email.change_email')
            });
            if (didConfirm) {
              try {
                const response = yield this.auth.currentUserModel.ciamInfo(undefined);
                if (response.can_user_update_email) {
                  yield this.updateEmail.perform(this.email);
                  this.router.transitionTo('user.signup.welcome', {
                    queryParams: {
                      alert: this.intl.t('account.users.edit_email.success_alert'),
                      title: this.intl.t('account.users.edit_email.success_title'),
                      description: this.intl.t('account.users.edit_email.success_description')
                    }
                  });
                  return;
                }
              } catch (error) {
                if (error.errors[0] === 'cannot update email') {
                  this.alerts.alert(this.intl.t('account.users.edit_email.cannot_update_description'), {
                    title: this.intl.t('account.users.edit_email.cannot_update_title'),
                    preventDuplicates: true
                  });
                } else {
                  const message = error?.errors?.at(-1)?.detail || error?.message;
                  if (message) {
                    this.errors.show(message);
                  }
                }
              }
            }
            this.handleClose.perform();
          } catch ({
            alert
          }) {
            this.alerts.add(alert);
          }
        }
      }), null, "handleSubmit", null));
    }
    get validationErrors() {
      if (this.email && this.confirmEmail) {
        if (this.email === this.auth.currentUserModel.email) {
          return this.intl.t('account.users.edit_email.validation_same');
        }
        if (this.email !== this.confirmEmail) {
          return this.intl.t('account.users.edit_email.validation_match');
        }
        if (!_constants.VALID_EMAIL_REGEX.test(this.email)) {
          return this.intl.t('account.users.edit_email.validation_email');
        }
      }
      return;
    }
    get hasValidationErrors() {
      return !!this.validationErrors;
    }
    get isSubmitDisabled() {
      return !this.email || !this.confirmEmail || this.hasValidationErrors;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "email", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "confirmEmail", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  })), _class);
});